import { render, staticRenderFns } from "./ReportPasses.vue?vue&type=template&id=c851f8da&scoped=true"
import script from "./ReportPasses.vue?vue&type=script&lang=js"
export * from "./ReportPasses.vue?vue&type=script&lang=js"
import style0 from "./ReportPasses.vue?vue&type=style&index=0&id=c851f8da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c851f8da",
  null
  
)

export default component.exports